(() => {
  const panel = document.querySelector('#hud-garage-panel');
  if (!panel) return;
  const root = document.querySelector('[data-hud-root-url]')?.dataset.hudRootUrl || '/';
  const read = (key, fallback) => { try { return JSON.parse(localStorage.getItem(key)) || fallback; } catch (_) { return fallback; } };
  const write = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); return true; } catch (_) { return false; } };
  const node = (tag, className, value) => { const el=document.createElement(tag);el.className=className||'';if(value)el.textContent=value;return el; };
  const vehicleKey = v => [v.year||'',v.make,v.model,v.generation,v.system||'',v.hud||''].join('|');
  const getVehicle = () => read('hud.vehicle.v1',null);
  const list = panel.querySelector('[data-hud-garage-list]');
  const message = panel.querySelector('[data-hud-garage-message]');
  function vehicleUrl(v) {
    const params = new URLSearchParams({hud_view:'catalog',hud_year:v.year||'',hud_make:v.make,hud_model:v.model,hud_generation:v.generation,hud_system:v.system||'',hud_hud:v.hud||''});
    return root+'?'+params+'#hud-results';
  }
  function render() {
    const garage=read('hud.garage.v2',[]),active=getVehicle();
    document.querySelectorAll('[data-hud-garage-count]').forEach(el=>el.textContent=String(garage.length));
    document.querySelectorAll('[data-hud-current-car]').forEach(el=>el.textContent=active?[active.year,active.make,active.model,active.generation].filter(Boolean).join(' · '):'Select a car');
    list.replaceChildren();
    const shown=[...garage];
    if(active&&!garage.some(v=>vehicleKey(v)===vehicleKey(active)))shown.unshift(active);
    if(!shown.length)list.append(node('p','hud-garage-empty','No cars saved yet. Select a vehicle above to get started.'));
    shown.forEach(v=>{
      const saved=garage.some(g=>vehicleKey(g)===vehicleKey(v)),isActive=active&&vehicleKey(active)===vehicleKey(v);
      const card=node('article','hud-garage-item'+(isActive?' is-active':''));
      if(isActive)card.append(node('span','hud-active-car','Selected car'));
      card.append(node('h3','',[v.year,v.make,v.model].filter(Boolean).join(', ')),node('p','',v.label||v.generation));
      if(v.system||v.hud)card.append(node('p','',[v.system,v.hud?'Head-Up Display: '+v.hud:''].filter(Boolean).join(' · ')));
      const browse=node('a','hud-secondary','Select Vehicle');browse.href=vehicleUrl(v);card.append(browse);
      const action=node('button','',saved?'Remove car':'Save to garage');action.type='button';
      action.addEventListener('click',()=>{
        const latest=read('hud.garage.v2',[]);
        const next=saved?latest.filter(g=>vehicleKey(g)!==vehicleKey(v)):latest.some(g=>vehicleKey(g)===vehicleKey(v))?latest:[...latest,v];
        const okay=write('hud.garage.v2',next);message.textContent=okay?(saved?'Car removed from this garage.':'Car saved to this garage.'):'Could not save this car on this device.';render();
      });
      card.append(action);list.append(card);
    });
  }
  function setOpen(open) {
    panel.hidden=!open;
    document.querySelectorAll('[data-hud-open-garage]').forEach(button=>button.setAttribute('aria-expanded',String(open)));
    if(open){render();panel.scrollIntoView({behavior:'smooth',block:'start'});}
  }
  document.querySelectorAll('[data-hud-open-garage]').forEach(button=>button.addEventListener('click',()=>setOpen(panel.hidden)));
  panel.querySelector('[data-hud-close-garage]').addEventListener('click',()=>{setOpen(false);document.querySelector('[data-hud-open-garage]')?.focus();});
  document.addEventListener('click',event=>{
    if(!event.target.closest('[data-hud-save-vehicle]'))return;
    const vehicle=getVehicle();if(!vehicle)return;
    const garage=read('hud.garage.v2',[]);if(!garage.some(v=>vehicleKey(v)===vehicleKey(vehicle)))garage.push(vehicle);
    const okay=write('hud.garage.v2',garage);message.textContent=okay?'Car saved to this garage.':'Could not save this car on this device.';render();
  });
  window.addEventListener('hud:vehicle',render);
  window.addEventListener('storage',render);
  render();
})();
